import { matching as en_matching } from "../en/matching";

/** matching — RU slice (71 keys). */
export const matching: Record<keyof typeof en_matching, string> = {
  location_disabled_title: "Соединение недоступно",
  location_disabled_description:
    "Чтобы пользоваться {name}, включи доступ к геолокации — так мы покажем, кто рядом с тобой.",
  location_disabled_hint:
    "Перейди в Настройки -> {name} -> Геолокация -> Разрешить при использовании приложения",
  location_disabled_button: "Открыть настройки",
  matching_no_potential_matches_title: "Упс!",
  matching_no_potential_matches_description:
    "Пока не можем найти людей рядом с тобой, попробуй позже",
  matching_no_potential_matches_button: "Попробовать снова",
  matching_loading_matches_title: "Ищем идеальную пару...",
  matching_loading_matches_description:
    "Подожди немного — мы просматриваем анкеты, чтобы найти для тебя лучшие знакомства. Это ненадолго.",
  matching_matched_title: "Это мэтч!",
  matching_matched_user_title: "Ты слинковался с {name}! ",
  matching_matched_user_button: "Выбери место для встречи",
  matching_pick_location_button: "Выбрать место встречи",
  match_location_new_matches: "НОВЫЕ МЭТЧИ ({count})",
  match_location_pick: "Выбрать место",
  match_location_your_turn: "Твой ход",
  match_location_waiting_short: "Ожидание",
  match_location_pick_spot_title: "Выбери место для встречи с {name}",
  match_location_popular_spots: "ПОПУЛЯРНЫЕ МЕСТА РЯДОМ",
  match_location_proposed_spots: "ПРЕДЛОЖЕННЫЕ МЕСТА",
  match_location_suggest_different: "Предложить другое место",
  match_location_enter_custom: "Указать своё место",
  match_location_your_pick: "ТЫ",
  match_location_their_pick: "{name}",
  match_location_waiting: "Ждём, пока {name} выберет...",
  match_location_different_picks: "Разные варианты!",
  match_location_different_picks_hint: "Выберите одно место, чтобы совпасть!",
  match_location_accept_their_spot: "Согласиться на их место",
  match_location_change_pick: "Изменить выбор",
  match_location_select: "Выбрать",
  match_location_confirm: "Подтвердить место",
  match_location_confirmed_title: "Это мэтч!",
  match_location_confirmed_subtitle: "Вы с {name} выбрали одно место",
  match_location_start_chatting: "Начать общение",
  match_location_meeting_at: "Встреча в {name}",
  match_location_navigate: "Проложить маршрут",
  match_location_search_placeholder: "Найти место...",
  match_location_category_cafe: "Кофейня",
  match_location_category_restaurant: "Ресторан",
  match_location_category_park: "Парк",
  match_location_category_bar: "Бар",
  match_location_category_museum: "Музей",
  match_location_category_mall: "Торговый центр",
  match_location_category_other: "Другое",
  match_location_distance_mi: "{distance} миль",
  match_location_error_propose: "Не удалось предложить место",
  match_location_error_load_spots: "Не удалось загрузить места",
  match_location_pick_title: "Выбери место для встречи с {name}",
  match_location_loading_spots: "Загружаем места...",
  match_location_no_spots: "Рядом нет доступных мест",
  match_location_no_spots_hint: "Попробуй предложить своё место ниже",
  match_location_header_title: "Выбор места",
  match_location_or: "ИЛИ",
  // --- Карточка встречи (всегда видна в личных чатах мэтчей) ---
  match_location_card_booked: "Забронировано ✅",
  match_location_card_pick_spot: "Выбрать место",
  match_location_card_waiting: "Ждём {name}",
  match_location_card_your_turn: "Твой ход",
  match_location_card_different_picks: "Разные места",
  match_location_card_no_spot_yet: "Место не выбрано",
  match_location_card_closed: "Мэтч закрыт",
  match_location_no_events_nearby: "Рядом нет событий",
  match_location_no_events_nearby_hint: "Попробуй позже",
  match_location_awaiting_decision: "Как прошла встреча с {name}?",
  match_location_awaiting_decision_pill: "Сначала решите",
  match_location_you_picked: "Вы выбрали {event}",
  match_location_they_picked: "{name} выбрал(а) {event}",
  match_location_default_name: "Ваш мэтч",
  match_location_default_title: "Место встречи",
  match_location_change_spot: "Изменить место",
  match_location_unmatched_message: "Этот мэтч закрыт.",
  match_location_unmatched_subtitle:
    "Переписка останется, но эта встреча завершена.",
  match_location_suggest_place: "Предложить другое место",
  match_location_custom_instructions:
    "Укажи место, где хотел бы встретиться. Добавь название и адрес, чтобы твоя пара смогла его найти.",
  match_location_name_label: "Название места",
  match_location_name_placeholder:
    "напр., Центральный парк, Моя любимая кофейня",
  match_location_address_label: "Адрес (необязательно)",
  match_location_address_placeholder: "напр., ул. Ленина, 123",
  match_location_use_current: "Использовать моё текущее местоположение",
  match_location_coordinates_set: "Координаты места заданы",
  match_location_preview: "Твоё предложение",
  match_location_confirm_location: "Подтвердить место",
  match_location_permission_denied_title: "Доступ к геолокации",
  match_location_permission_denied_message:
    "Разреши доступ к геолокации в настройках устройства, чтобы пользоваться этой функцией.",
  match_location_get_location_error:
    "Не удалось определить твоё местоположение",
  match_location_name_required: "Введи название места",
  match_location_propose_error: "Не удалось предложить место. Попробуй снова.",
  match_location_chat_error: "Не удалось открыть чат. Попробуй снова.",
};
